import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from "react-bootstrap";
import { secondsToTime } from "../../utilities/scoringUtilities";
import { MatchEvents } from "../../models/enums/MatchEvents";
import { PenaltyOutcome } from "../../models/enums/PenaltyOutcome";
import { PenaltyReason } from "../../models/enums/PenaltyReason";
import { LineoutTarget } from "../../models/enums/LineoutTarget";
import { FreekickOutcome } from "../../models/enums/FreekickOutcome";
import scoringService from "../../services/ScoringService";

import { v4 as uuidv4 } from "uuid";

const ScrumInfoUpdate = (props) => {
  const {
    onCancelClipButtonClick,
    isWon,
    setIsWon,
    isScrumPenalty,
    setIsScrumPenalty,
    isFreekick,
    setIsFreekick,
    realMarkerX,
    realMarkerY,
    clipSelected,
    setClip,
  } = props;

  const [freekickSelected, setFreekickSelected] = useState(null);
  const [penaltySelected, setPenaltySelected] = useState(null);

  const handleWonOrLostStatus = (isWon) => {
    setIsWon(isWon);
  };

  const handleFreekickStatus = async (status) => {
    if (
      freekickSelected === true ||
      !clipSelected.freekickResult ||
      clipSelected.freekickResult !== status
    ) {
      await setIsFreekick((prevState) =>
        prevState === status ? null : status
      );
    } else {
      await setIsFreekick(null);
    }
    await setFreekickSelected(true);
  };

  const handlePenaltyStatus = async (status) => {
    if (
      penaltySelected === true ||
      !clipSelected.penaltyResult ||
      clipSelected.penaltyResult !== status
    ) {
      await setIsScrumPenalty((prevState) =>
        prevState === status ? null : status
      );
    } else {
      await setIsFreekick(null);
    }
    await setPenaltySelected(true);
  };

  let markerX = realMarkerX ? realMarkerX : clipSelected.positionX;
  let markerY = realMarkerY ? realMarkerY : clipSelected.positionY;
  let wonOrLost = isWon !== null ? isWon : clipSelected.matchEventWon;
  let freekick = freekickSelected ? isFreekick : clipSelected.freekickResult;
  let penalty = penaltySelected ? isScrumPenalty : clipSelected.penaltyResult;

  return (
    <>
      <div
        className="d-flex flex-fill justify-content-end align-items-end"
        style={{ marginTop: "-1.5em" }}
      >
        <Button
          className="ml-1"
          variant="outline-primary"
          size="md"
          disabled={wonOrLost !== null ? false : true}
          onClick={async (e) => {
            await setClip(
              clipSelected.id,
              markerX,
              markerY,
              clipSelected.type,
              clipSelected.teamId,
              clipSelected.teamId,
              wonOrLost,
              null,
              freekick,
              penalty
            );
            await setFreekickSelected(false);
          }}
        >
          Confirm Update Scrum
        </Button>
        <Button
          className="ml-1"
          variant="outline-danger"
          size="md"
          onClick={async (e) => {
            await onCancelClipButtonClick();
            await setFreekickSelected(false);
          }}
        >
          Cancel
        </Button>
      </div>
      <div className="col-md-12 text-center">
        <Row style={{ marginTop: "4rem" }}>
          <Col xs={4} className="flex-column align-items-center" style={{marginTop: "-2.5rem"}}>
          <h5>Outcome</h5>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: wonOrLost ? "#70747c" : "",
                  color: wonOrLost ? "white" : "",
                }}
                onClick={async() => await handleWonOrLostStatus(true)}
              >
                WON
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: wonOrLost === false? "#70747c" : "",
                  color: wonOrLost === false ? "white" : "",
                }}
                onClick={async() => await handleWonOrLostStatus(false)}
              >
                LOST
              </Button>
            </div>
          </Col>
          <Col xs={4} className="flex-column align-items-center" style={{marginTop: "-1rem"}}>
            <h5></h5>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "170px",
                  height: "40px",
                  backgroundColor:
                    penalty === PenaltyOutcome.PenaltyFor ? "#70747c" : "",
                  color:
                  penalty === PenaltyOutcome.PenaltyFor ? "white" : "",
                }}
                onClick={() =>
                  handlePenaltyStatus(PenaltyOutcome.PenaltyFor)
                }
              >
                PENALTY FOR
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "170px",
                  height: "40px",
                  backgroundColor:
                  penalty === PenaltyOutcome.PenaltyAgainst
                      ? "#70747c"
                      : "",
                  color:
                  penalty === PenaltyOutcome.PenaltyAgainst
                      ? "white"
                      : "",
                }}
                onClick={() =>
                  handlePenaltyStatus(PenaltyOutcome.PenaltyAgainst)
                }
              >
                PENALTY AGAINST
              </Button>
            </div>
          </Col>
          <Col xs={4} className="flex-column align-items-center" style={{marginTop: "-1rem"}}>
            <h5></h5>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "170px",
                  height: "40px",
                  backgroundColor:
                    freekick === FreekickOutcome.FreeKickFor ? "#70747c" : "",
                  color:
                    freekick === FreekickOutcome.FreeKickFor ? "white" : "",
                }}
                onClick={() =>
                  handleFreekickStatus(FreekickOutcome.FreeKickFor)
                }
              >
                FREE KICK FOR
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "170px",
                  height: "40px",
                  backgroundColor:
                    freekick === FreekickOutcome.FreeKickAgainst
                      ? "#70747c"
                      : "",
                  color:
                    freekick === FreekickOutcome.FreeKickAgainst
                      ? "white"
                      : "",
                }}
                onClick={() =>
                  handleFreekickStatus(FreekickOutcome.FreeKickAgainst)
                }
              >
                FREE KICK AGAINST
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ScrumInfoUpdate;
